import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("请输入有效的电子邮件地址")
    .required("请输入电子邮件地址"),
  password: yup.string().required("请输入密码"),
});
